import { fmtDate } from '../lib/format';
import { useApi } from '../lib/useApi';

// Nach Mandatsende (Admin, „Beendete Mandate“): Rechnungen aus dem Rechnungswerkzeug als ZIP für den Mandanten, bis die
// App sie mit den Unterlagen löscht. Firmen ohne Belege dort bekommen keinen Knopf.

// Anzahl Belege (Rechnungen, Angebote, Auftragsbestätigungen, Lieferscheine) je beendeter Firma; lädt erst, wenn die
// Liste offen ist
export function useRtBeendet(open: boolean): Record<string, number> {
  const res = useApi<{ clients: Record<string, number> }>(open ? '/api/kanzlei/rechnungstool/beendet' : null, {
    live: ['clients'],
  });
  return res.data?.clients ?? {};
}

export function RtZipLink({ clientId, name, count }: { clientId: string; name: string; count: number | undefined }) {
  if (!count) return null;
  return (
    <a
      className="btn sm"
      href={`/api/kanzlei/rechnungstool/${clientId}/export`}
      download
      aria-label={`${count} ${count === 1 ? 'Beleg' : 'Belege'} von ${name} aus dem Rechnungsprogramm als ZIP laden`}
    >
      Rechnungen (ZIP)
    </a>
  );
}

// Vor dem Beenden (Nachtrag N8): Hat die Firma Belege im Rechnungswerkzeug, sieht der Admin, wie viele und bis wann er
// sie als ZIP schicken kann. Der Mandant bekommt dazu beim Beenden eine Mail.
export function RtEndeHinweis({ clientId }: { clientId: string }) {
  const res = useApi<{
    rechnungen: number;
    angebote?: number;
    auftraege?: number;
    lieferscheine?: number;
    purgeOn: string | null;
    mail: boolean;
  }>(`/api/kanzlei/rechnungstool/${clientId}/ende`);
  const d = res.data;
  if (!d) return null;
  const mal = (n: number | undefined, eins: string, viele: string) => (n ? `${n} ${n === 1 ? eins : viele}` : null);
  const teile = [
    mal(d.rechnungen, 'Rechnung', 'Rechnungen'),
    mal(d.angebote, 'Angebot', 'Angebote'),
    mal(d.auftraege, 'Auftragsbestätigung', 'Auftragsbestätigungen'),
    mal(d.lieferscheine, 'Lieferschein', 'Lieferscheine'),
  ].filter((x): x is string => !!x);
  if (!teile.length) return null;
  // „a, b und c“
  const n = teile.length > 1 ? `${teile.slice(0, -1).join(', ')} und ${teile.at(-1)}` : teile[0];
  return (
    <p className="note" role="note">
      Im Rechnungsprogramm hat die Firma {n}. Die muss der Mandant selbst aufbewahren.{' '}
      {d.purgeOn
        ? `Bis zum ${fmtDate(d.purgeOn)} können Sie sie ihm unter „Beendete Mandate“ als ZIP schicken, danach löscht die App sie.`
        : 'Unter „Beendete Mandate“ können Sie sie ihm als ZIP schicken (Löschsperre an).'}{' '}
      {d.mail
        ? 'Der Mandant bekommt beim Beenden eine E-Mail dazu; antwortet er, landet die Antwort bei Ihnen.'
        : 'E-Mail ist nicht eingerichtet: Bitte sagen Sie es dem Mandanten selbst.'}
    </p>
  );
}
